import * as Sentry from '@sentry/nuxt'
import { useRuntimeConfig } from '#imports'

const IS_PROD = !!Number(import.meta.env.VITE_IS_PROD_ENV)

Sentry.init({
  environment: IS_PROD ? 'production' : 'test',
  dsn: 'https://b6845b55179807ddf7abcfe5905bf4e4@sg-sentry.changzhi.top/15',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
})
